import styled from "styled-components";
import { H2, P } from "@/lib/styles";
import { smallLabelTypographicStyle } from "@/lib/styles/helpers";

export const FormElement = styled.form`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-wrap: wrap;
  padding: 2.5rem 0 0.5rem;
  justify-content: space-between;

  * {
    box-sizing: border-box;
  }
`;

export const Title = styled(H2)`
  ${({ theme }) => theme.mediaQueries.tablet} {
    margin-bottom: 1.5rem;
  }
`;

export const Subtitle = styled(P)`
  background-color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.mediaQueries.tablet} {
    padding: 1rem 0;
  }
`;

export const DropDownCheckMark = styled.span`
  height: 1.5rem;
  min-height: 1.5rem;
  width: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  margin-right: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black};

  & svg {
    display: none;
  }
`;

export const DropDownOption = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  ${smallLabelTypographicStyle}

  &:hover ${DropDownCheckMark} {
    background-color: ${({ theme }) => theme.colors.black};
  }

  &.active ${DropDownCheckMark} {
    background-color: ${({ theme }) => theme.colors.black};

    svg {
      display: block;
      fill: white;
    }
  }
`;
